import { createBrowserRouter, Navigate } from 'react-router-dom';
import { GuestRoute } from './components/GuestRoute';
import { Dashboard } from './components/Dashboard';
import { ApiTokens } from './components/ApiTokens';
import { Gallery } from './components/Gallery';
import { Tasks } from './components/Tasks';
import { ProtectedRoute } from './components/ProtectedRoute';
import { NotesList } from './pages/Notes/NotesList';
import { NoteForm } from './pages/Notes/NoteForm';
import { NoteView } from './pages/Notes/NoteView';
import { GallerySlider } from "./components/GallerySlider.tsx";
import { AccountingTable } from './components/Accounting';
import { MindMapNotes } from './components/MindMapNotes';
import MindMap from './components/mind-map/MindMap';
import { FileExplorer } from './components/FileExplorer.tsx';
import { ExternalAssets } from './components/ExternalAssets';
import { Projects } from './components/Projects';
import { PathOpener } from './components/PathOpener';
import { Account } from './components/Account';
import { Login } from './components/Login';
import { DeviceLogin } from './components/DeviceLogin';
import { DeviceLink } from './components/DeviceLink';
import { MusicPage } from './components/music/MusicPage';

export const router = createBrowserRouter([
    {
        element: <GuestRoute />,
        children: [
            {
                path: '/login',
                element: <Login />
            },
            {
                path: '/device-login',
                element: <DeviceLogin />
            },
        ],
    },
    {
        path: '/',
        element: <ProtectedRoute />,
        children: [
            {
                index: true,
                element: <Navigate to="/dashboard" replace />
            },
            {
                path: 'dashboard',
                element: <Dashboard />
            },
            {
                path: 'link',
                element: <DeviceLink />
            },
            {
                path: 'api-tokens',
                element: <ApiTokens />
            },
            {
                path: 'account',
                element: <Account />
            },
            {
                path: 'gallery',
                children: [
                    { index: true, element: <Gallery /> },
                    { path: 'album/:albumId', element: <Gallery /> },
                ],
            },
            {
                path: 'gallery-slider',
                element: <GallerySlider />
            },
            {
                path: 'tasks',
                element: <Tasks />
            },
            {
                path: 'notes',
                element: <NotesList />
            },
            {
                path: 'notes/create',
                element: <NoteForm />
            },
            {
                path: 'notes/:id',
                element: <NoteView />
            },
            {
                path: 'notes/:id/edit',
                element: <NoteForm />
            },
            {
                path: 'accounting',
                element: <AccountingTable />
            },
            {
                path: 'mind-map-notes',
                element: <MindMapNotes />
            },
            {
                path: 'mind-map',
                element: <MindMap />
            },
            {
                path: 'file-manager',
                element: <FileExplorer />
            },
            {
                path: 'external-assets',
                element: <ExternalAssets />
            },
            {
                path: 'projects',
                element: <Projects />
            },
            {
                path: 'path-opener',
                element: <PathOpener />
            },
            {
                path: 'music',
                element: <MusicPage />
            }
        ]
    }
]);
